module.exports = __webpack_public_path__ + "img/rooseanelogo.a8fce845.png";